import { Grid } from "@mui/material";
import { useEffect, useState } from "react";

import Box from "../Box";
import Modal from "../Modal";
import Switch from "../Switch";
import Typography from "../Typography";
import TitleValue from "../TitleValue";
import Autocomplete from "../Autocomplete";
import Helpers from "../../commons/helpers";
import useStrings from "../../hooks/useStrings";

import { IsTrue } from "../../constants/enums";
import { ICodename } from "../../commons/interfaces";
import { IGroupUserResponses } from "../../containers/group/edit";



const ModalUpdateGroupUser = (props: {
    newLableGroup?: string;
    newLableStaff?: string;
    listUserTitle?: ICodename[];

    dataUserGroup: (IGroupUserResponses & { action: number }) | undefined;

    onClose: () => void;
    onSubmit: (newData: (IGroupUserResponses & { action: number }) | undefined) => void;
}) => {
    const strings = useStrings();
    const [itemUserGroup, setItemUserGroup] = useState<(IGroupUserResponses & { action: number }) | undefined>(undefined);

    useEffect(() => {
        if (!Helpers.isNullOrEmpty(props.dataUserGroup?.id)) {
            setItemUserGroup(props.dataUserGroup);
        }
    }, [props.dataUserGroup?.id]);

    return (
        <Modal
            fullWidth
            maxWidth="md"
            hasActionButton
            visible={!Helpers.isNullOrEmpty(props.dataUserGroup?.id)}
            title={strings.format(strings.Staff.BASIC_INFO, props.newLableStaff)}

            onAction={() => {
                props.onSubmit(itemUserGroup);
                setItemUserGroup(undefined);
            }}
            onClose={() => {
                props.onClose();
                setItemUserGroup(undefined);
            }}
        >
            <Grid container spacing={1} p={2}>
                <Grid item xs={12}>
                    <TitleValue
                        title={strings.Staff.FULL_NAME}
                        value={
                            `${itemUserGroup?.userProfile?.lastName || ""} ${itemUserGroup?.userProfile?.firstName || ""}`.trim()
                        }
                    />
                </Grid>
                <Grid item xs={12}>
                    <TitleValue
                        title={strings.Staff.PHONE_NUMBER}
                        value={itemUserGroup?.userProfile?.phoneNumber || ""}
                    />
                </Grid>
                <Grid item xs={12}>
                    <TitleValue
                        title={strings.Staff.EMAIL}
                        value={itemUserGroup?.userProfile?.email || ""}
                    />
                </Grid>
                <Grid item xs={12}>
                    <TitleValue
                        title={strings.format(strings.Staff.STAFF_PERMISSION, props.newLableStaff)}
                        value={[...itemUserGroup?.userRoles || []].map((el) => el.roleName).join("; ") || ""}
                    />
                </Grid>

                <Grid item xs={12}>
                    <Box sx={{
                        gap: 1,
                        display: "flex",
                        flexWrap: "wrap",
                        alignItems: "center",
                    }}>
                        <Switch
                            checked={Number(itemUserGroup?.manager) === IsTrue.True}
                            onChange={(event, checked) => {
                                const value = (checked === true) ? IsTrue.True : IsTrue.False;
                                setItemUserGroup(prev => ({
                                    ...prev,
                                    manager: value,
                                }));
                            }}
                        />
                        <Typography variant="button" fontWeight={"bold"}>
                            {Helpers.capitalizeFirstLetter(strings.format(strings.Staff.MANAGER_GROUP, props.newLableGroup))}
                        </Typography>
                    </Box>
                </Grid>

                <Grid item xs={12}>
                    <Box>
                        <Typography variant="button" fontWeight={"bold"}>
                            {Helpers.capitalizeFirstLetter(strings.format(strings.Staff.STAFF_POSITION, props.newLableStaff))}:
                        </Typography>
                        <Autocomplete
                            label={""}
                            data={props.listUserTitle || []}
                            defaultValue={itemUserGroup?.userTitle}
                            placeholder={Helpers.capitalizeFirstLetter(strings.format(strings.Staff.SELECT_STAFF_POSITION, props.newLableStaff))}
                            onChange={(value) => {
                                setItemUserGroup(prev => ({
                                    ...prev,
                                    userTitle: value,
                                }));
                            }}
                        />
                    </Box>
                </Grid>
            </Grid>
        </Modal>
    );
};

export default ModalUpdateGroupUser;